<!--<kendo-tabstrip [scrollable]="true" [tabPosition]="position" class="k-tabstrip tab-inventory-usage-report">-->
 <!--[tabPosition]="position"-->
<kendo-tabstrip id="k-tabstrip" class="k-tabstrip tab-inventory-usage-report">
  <kendo-tabstrip-tab title="Budget Report" [selected]="true">
    <ng-template kendoTabContent>
      <section>
        <app-budget-report></app-budget-report>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="Budget Allocations">
    <ng-template kendoTabContent>
      <section>
        <app-allocation-report></app-allocation-report>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
